import { Card } from 'react-bootstrap';
import { ChevronDown, ChevronUp, ArrowUp, ArrowDown, Dash } from 'react-bootstrap-icons';
import { Droplet, ThermometerHalf, Moisture } from 'react-bootstrap-icons';

const sensorIcons = {
  soil_moisture: Moisture,
  temperature: ThermometerHalf,
  humidity: Droplet,
};

const sensorUnits = {
  soil_moisture: '%',
  temperature: '°C',
  humidity: '%',
};

const getTrend = (current, previous) => {
  if (current == null || previous == null || current === previous) return 'flat';
  return current > previous ? 'up' : 'down';
};

const TrendIndicator = ({ trend }) => {
  if (trend === 'up') return <ArrowUp size={14} className="metric-trend metric-trend--up" />;
  if (trend === 'down') return <ArrowDown size={14} className="metric-trend metric-trend--down" />;
  return <Dash size={14} className="metric-trend metric-trend--flat" />;
};

const MetricCard = ({
  title,
  value,
  unit,
  sensorType,
  variant = 'sensor',
  expanded = false,
  trend,
  onClick,
  children,
  className = '',
}) => {
  const Icon = sensorIcons[sensorType] || Droplet;
  const displayUnit = unit ?? sensorUnits[sensorType] ?? '';
  const cardClass = variant === 'digital' ? 'digital-card' : 'sensor-card';
  const displayValue = value ?? 'N/A';

  return (
    <Card
      className={`h-100 ${cardClass} ${expanded ? 'sensor-card-expanded' : ''} metric-card ${className}`}
      style={{ cursor: onClick ? 'pointer' : undefined }}
      onClick={onClick}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div className="d-flex align-items-center gap-2">
            <Icon size={20} className="metric-card__icon" />
            <Card.Title className="metric-card__title mb-0">{title}</Card.Title>
          </div>
          {onClick && (expanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />)}
        </div>
        <div className="metric-card__value-row">
          <span className="metric-card__value">{displayValue}</span>
          {displayValue !== 'N/A' && displayUnit && (
            <span className="metric-card__unit">{displayUnit}</span>
          )}
          {trend && <TrendIndicator trend={trend} />}
        </div>
        {children}
      </Card.Body>
    </Card>
  );
};

export { getTrend, sensorUnits };
export default MetricCard;